<template>
    <section class="animated-hero">
      <slot></slot>
    </section>
  </template>
  
  <script>
  export default {
    name: 'AnimatedHero',
    // Add any component logic here
  }
  </script>
  
  <style scoped>
  .animated-hero {
    position: relative;
    width: 100%;
    min-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    color: white;
    padding: 2rem 0;
  }
  
  /* Add your animation styles here */
  </style>